import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const GroupFilledIcon: FC<IconProps> = ({ width = 36, height = 32, ...rest }) => (
  <Icon type="GroupFilled" width={width} height={height} alt="group of people" {...rest} />
)
